'use strict';exports.__esModule = true;exports.receivePropertyTypes = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _set = require('lodash/set');var _set2 = _interopRequireDefault(_set);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _constants = require('../../constants');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var receivePropertyTypes = (0, _reduxAct.createAction)('/RECEIVE_PROPERTY_TYPES');
var receivePropertyTypesSuccess = (0, _reduxAct.createAction)('/RECEIVE_PROPERTY_TYPES_SUCCESS');
var receivePropertyTypesFail = (0, _reduxAct.createAction)('/RECEIVE_PROPERTY_TYPES_FAIL');

var sortPropertyTypes = function sortPropertyTypes() {var propertyTypes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var sortedData = {};

  if ((0, _get2.default)(propertyTypes, '[0].fromSection')) {var
    sections = _constants.publishConfig.sections,optionTypes = _constants.publishConfig.optionTypes;

    sections.forEach(function (section) {
      var filteredBySection = propertyTypes.filter(function (item) {return item.fromSection.includes(section);});

      optionTypes.forEach(function (opType) {
        var filteredByOption = filteredBySection.
        filter(function (item) {return item.fromOptionType.includes(opType);}).
        map(function (_ref) {var name = _ref.name;return name;});

        (0, _set2.default)(sortedData, section + '.' + opType, filteredByOption);
      });
    });
  }

  return sortedData;
};

var initialState = {
  loading: false,
  loaded: false };


var fetchReceive = function fetchReceive() {return _axios2.default.get('/property-types', {
    params: { full: true, sections: _constants.publishConfig.sections, options: _constants.publishConfig.optionTypes } }).

  then(receivePropertyTypesSuccess, receivePropertyTypesFail);};

var receiveHandler = function receiveHandler(state) {return (0, _reduxLoop.loop)(Object.assign({}, state, { loading: true }), promise(fetchReceive));};
var receiveHandlerSuccess = function receiveHandlerSuccess(state, response) {
  var sortedTypes = sortPropertyTypes(response.data);
  return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: response.data,
    sorted: sortedTypes });

};

var receiveHandlerFail = function receiveHandlerFail(state, response) {
  var error = (0, _formatApiError2.default)(response, 'Error while getting property types');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: [],
    sorted: undefined,
    error: error });

};

var propertyTypes = (0, _reduxAct.createReducer)(function (on) {
  on(receivePropertyTypes, receiveHandler);
  on(receivePropertyTypesSuccess, receiveHandlerSuccess);
  on(receivePropertyTypesFail, receiveHandlerFail);
}, initialState);exports.


receivePropertyTypes = receivePropertyTypes;exports.default =


propertyTypes;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/propertyTypes.js
// module id = 1281
// module chunks = 0